export const accountSamlStatuses = ['active', 'pending'] as const
export type AccountSamlStatus = (typeof accountSamlStatuses)[number]
export type AccountSaml = {
  status: AccountSamlStatus
  identifier: string
  idpMetadataUrl?: string
  idpEntityId?: string
  idpRedirectUrl?: string
  idpCert?: string
  jitProvisioning?: boolean
  forceAuthn?: boolean
  requiresSignedAuthn?: boolean
  wantAssertionsSigned?: boolean
  wantAuthnResponseSigned?: boolean
  emailDomains?: string[]
  domainBlacklist?: string[]

  attributeMapping?: {
    email?: string
    firstName?: string
    lastName?: string
    jobTitle?: string
    phoneNumber?: string
    groups?: string
  }
}

export type AccountMfa = {
  forceMfa?: boolean
}

export type AccountSecurity = {
  mfa?: AccountMfa
  saml?: AccountSaml
}
